
const SECRET_KEY = process.env.REACT_APP_SECRET_KEY || "default_secret_key";

export const xorEncrypt = (data) => {
  const key = SECRET_KEY;
  if (!data) {
    console.error("Encryption error: No data provided");
    return null;
  }
  const strData = typeof data === "string" ? data : JSON.stringify(data);
  const encrypted = strData
    .split("")
    .map(
      (char, index) => char.charCodeAt(0) ^ key.charCodeAt(index % key.length)
    )
    .join(",");
  //console.log(`Encrypting data: ${strData} to ${encrypted}`);
  return encrypted;
};

export const xorDecrypt = (encryptedData) => {
  const key = SECRET_KEY;
  if (!encryptedData) {
    console.error("Decryption error: No data provided");
    return null;
  }
  const decryptedStr = encryptedData
    .split(",")
    .map((charCode, index) =>
      String.fromCharCode(charCode ^ key.charCodeAt(index % key.length))
    )
    .join("");
  try {
    return decryptedStr;
  } catch (e) {
    return decryptedStr;
  }
};
